<template>
	<MinMax :index="index"></MinMax>
</template>
<script type="text/javascript">
	import MinMax from '../../componentsToQuestions/Min-Max.vue';

	export default {
		props: ['index'],
		components: { MinMax },
	}
	
</script>